/**
 * 国保連提出資料（R-21）
 * 国保連の提出様式は地域・年度により異なるため、所轄の国保連に様式をご確認いただき、
 * 帳票出力センターから必要なデータ（試算表・資金収支計算書等）を出力してご利用ください。
 */
import React from 'react';

interface KokuhoRenExportProps {
  onNavigate?: (menuId: string) => void;
}

const KokuhoRenExport: React.FC<KokuhoRenExportProps> = ({ onNavigate }) => {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h1 className="text-xl font-bold text-gray-800 mb-6">国保連提出用資料</h1>

      <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 mb-6 text-sm text-gray-700">
        <p className="font-medium text-amber-900 mb-1">ご利用にあたって</p>
        <p>
          国民健康保険団体連合会（国保連）への提出様式・フォーマットは、<strong>地域および年度により異なります</strong>。
          所轄の国保連に最新の様式をご確認のうえ、必要に応じて以下の帳票データをご利用ください。
        </p>
      </div>

      <div className="bg-white border rounded-lg shadow p-6 space-y-4">
        <h2 className="text-lg font-medium text-gray-900">利用可能な帳票データ</h2>
        <p className="text-sm text-gray-600">
          帳票出力センターから、国保連提出のベースデータとして次のような帳票をCSV・PDFで出力できます。
        </p>
        <ul className="list-disc list-inside text-sm text-gray-700 space-y-1">
          <li>合計残高試算表（精算表）… CSV</li>
          <li>資金収支計算書（第1号様式）… PDF</li>
          <li>事業活動収支計算書（第2号様式）… PDF</li>
          <li>貸借対照表（第3号様式）… PDF</li>
          <li>総勘定元帳・仕訳帳 … CSV</li>
        </ul>
        {onNavigate && (
          <button
            type="button"
            onClick={() => onNavigate('report-output')}
            className="mt-4 px-4 py-2 bg-indigo-600 text-white rounded hover:bg-indigo-700 text-sm"
          >
            帳票出力センターを開く
          </button>
        )}
      </div>

      <div className="mt-6 text-xs text-gray-500">
        <p>※ 国保連の正式様式に合わせた専用CSVは、様式確定後に追加実装の可能性があります。要望はお問い合わせください。</p>
      </div>
    </div>
  );
};

export default KokuhoRenExport;
